export default __webpack_public_path__ + "static/media/power4.60c1f91c.svg";